import React, { useContext, useEffect, useState } from 'react';
import { CiEdit } from 'react-icons/ci';
import SearchableDropDownCodeMozoee from '../../../SearchableDropDown/SearchableDropDownCodeMozoee.tsx';
import { DataContext } from '../../../context/DataProvider.tsx';
import { IoNewspaperOutline } from 'react-icons/io5';
import { format as jalaliFormat } from 'date-fns-jalali';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import SearchableDropDownExecutiveParentId from '../../../SearchableDropDown/SearchableDropDownExecutiveParentId.tsx';
import SearchableDropDownExecutivePrevOrgId from '../../../SearchableDropDown/SearchableDropDownExecutivePrevOrgId.tsx';

const CardTitlesExecutiveAndApproval = () => {
  const {
    isTokenExpired,
    tokenLogin,
    fetchRefreshToken,
    toggleSabt,
    setToggleSabt,
    titExecutive,
    setTitExecutive,
    executivSectionText,
    setExecutivSectionText,
    statusExeAndApr,
    setStatusExeAndApr,
    toggleDToM,
    setToggleDToM,
  } = useContext(DataContext);

  // console.log('statusExeAndApr', titExecutive);

  const [stateId, setStateId] = useState([]);

  const handleDateCreate = (date: any) => {
    setTitExecutive((caseData) => ({
      ...caseData,
      CreateDate: jalaliFormat(new Date(date), 'yyyy/MM/dd'),
    }));
  };

  const handleDateExpir = (date: any) => {
    setTitExecutive((caseData) => ({
      ...caseData,
      ExpireDate: jalaliFormat(new Date(date), 'yyyy/MM/dd'),
    }));
  };

  useEffect(() => {
    return () => {};
  }, [titExecutive, titExecutive.State_ID, titExecutive.ID]);

  const newSubFun = () => {
    try {
      setTitExecutive((prev) => ({
        ...prev,
        ID: 0,
        Parent_ID: 0,
        Title: '',
        CreateDate: '',
        ExpireDate: '',
        IsCategory: false,
        State_ID: null,
        isForign: false,
        Domain: '',
        PrevOrg_ID: 0,
        Comment: '',
        IsExecutor: false,
        inActive: false,
      }));
      setExecutivSectionText([]);
    } catch (error) {
      console.log('error', error);
    }
  };

  // console.log(
  //   'statusExeAndApr.filter(',
  //   statusExeAndApr.filter((item) => item.ID == titExecutive.State_ID)[0]
  //     ? statusExeAndApr.filter((item) => item.ID == titExecutive.State_ID)[0]
  //     : 'سلام',
  // );
  // console.log('titExecutive.State_ID', titExecutive.State_ID);
  // console.log('statusExeAndApr', statusExeAndApr);
  // console.log(
  //   'statusExeAndApr.filter=======>',
  //   titExecutive.State_ID
  //     ? statusExeAndApr.find((item) => item.ID == titExecutive.State_ID)?.ID
  //     : //  || ''
  //       '',
  // );
  // console.log(statusExeAndApr);
  const upsertSubFun = async () => {
    if (!validateTitle(titExecutive.Title)) {
      // alert('لطفا عنوان را به درستی وارد نمایید');
      alert(
        'لطفا عنوان را به درستی وارد نمایید. عنوان نباید خالی باشد یا شامل کاراکترهای غیرمجاز (مانند ,!@#$%^&*)(_+-<>./) باشد.',
      );
      return;
    }
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/Organization/Upsert`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Methods':
                'GET,OPTIONS,PATCH,DELETE,POST,PUT',
              'Access-Control-Allow-Headers':
                'X-Requested-With, Content-Type, Authorization',
              'Access-Control-Allow-Credentials': 'true',
            },
            body: JSON.stringify({
              id: titExecutive.ID,
              parent_ID: titExecutive.Parent_ID,
              title: titExecutive.Title,
              dotic_ID: titExecutive.dotic_ID,
              createDate: titExecutive.CreateDate,
              ordering: titExecutive.Ordering,
              expireDate: titExecutive.ExpireDate,
              isCategory: titExecutive.IsCategory,
              state_ID: titExecutive.State_ID,
              isForign: titExecutive.isForign,
              domain: titExecutive.Domain,
              isExecutor: titExecutive.IsExecutor,
              prevOrg_ID: titExecutive.PrevOrg_ID,
              nextOrg_ID: titExecutive.NextOrg_ID,
              comment: titExecutive.Comment,
              user_ID: titExecutive.User_ID,
              inActive: titExecutive.inActive,
              report_ID: titExecutive.Report_ID,
              topLaws: titExecutive.TopLaws,
              topTopic: titExecutive.TopTopic,
              header: titExecutive.Header,
              icon: titExecutive.Icon,
            }),
          },
        ).then((res) => {
          // console.log(res.json());
          setToggleSabt(!toggleSabt);
          if (res.status === 200) {
            alert('ویرایش با موفقیت انجام شد');

            setTitExecutive((prev) => ({
              ...prev,
              ID: 0,
              Parent_ID: 0,
              Title: '',
              CreateDate: '',
              ExpireDate: '',
              IsCategory: false,
              State_ID: null,
              isForign: false,
              Domain: '',
              PrevOrg_ID: 0,
              Comment: '',
              IsExecutor: false,
              inActive: false,
            }));
            setExecutivSectionText([]);
          }
        });
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchRefreshToken();
      // alert('برای شما دسترسی جدید صادر گردید، لطفا مجددا تلاش نمایید');
    }
  };

  // یک تابع برای اعتبارسنجی عنوان
  const validateTitle = (title: string) => {
    // حذف فضاهای خالی از ابتدا و انتها
    const trimmedTitle = title.trim();

    // چک کردن کاراکترهای غیرمجاز
    // const invalidChars = /[,!@#$%^&*)(_+-<>./\\]/;
    const invalidChars = /[,!@#$%^&)(_+-./\\]/;

    if (!trimmedTitle || invalidChars.test(trimmedTitle)) {
      return false;
    }
    return true;
  };

  return (
    <>
      <div className="card-with-scroll col-span-3 pb-10">
        <div className="w-full flex items-center justify-center">
          {toggleDToM ? (
            <div className="w-full  text-center mb-2 bg-[#96a6ee] p-2 rounded-lg">
              <p className="font-IranSans text-sm text-white">
                <b> ویرایش عناوین دستگاه های اجرایی </b>
              </p>
              <p className="font-IranSans mr-3 text-sm"></p>
            </div>
          ) : (
            <div className="w-full  text-center mb-2 bg-[#80cfae] p-2 rounded-lg">
              <p className="font-IranSans text-sm text-white">
                <b> ویرایش عناوین مراجع تصویب </b>
              </p>
              <p className="font-IranSans mr-3 text-sm"></p>
            </div>
          )}
          {/* <div className="w-full  text-center mb-2 bg-[#96a6ee] p-2 rounded-lg">
            <p className="font-IranSans text-sm text-white">
              <b> ویرایش عناوین دستگاه های اجرایی </b>
            </p>
            <p className="font-IranSans mr-3 text-sm"></p>
          </div> */}
        </div>
        <div className="max-w-full mx-auto ">
          <div className="border-b border-gray-200 dark:border-gray-700 mb-4"></div>

          <div className="w-full border rounded-md p-5 border-[#cbd5e1]">
            <div className="w-full grid grid-cols-2 gap-10 mt-5 ">
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  عنوان
                </label>
                {/* <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  // value={titSubID.Title}
                  value={titExecutive.Title}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Title: e.target.value,
                    }))
                  }
                /> */}
                {/* // تغییر در onChange عنوان */}
                <input
                  type="text"
                  className="w-full border outline-none p-2 rounded-md"
                  value={titExecutive.Title}
                  onChange={(e) => {
                    // const newTitle = e.target.value;
                    // if (validateTitle(newTitle)) {
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Title: e.target.value,
                      // Title: newTitle,
                    }));
                    // } else {
                    //   alert(
                    //     'لطفا عنوان را به درستی وارد نمایید. عنوان نباید خالی باشد یا شامل کاراکترهای غیرمجاز (مانند ,!@#$%^&*)(_+-<>./) باشد.',
                    //   );
                    // }
                  }}
                />
              </div>

              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  ترتیب
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.Ordering}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Ordering: e.target.value,
                    }))
                  }
                />
              </div> */}
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  وضعیت
                </label>
                <div
                  //  className="relative"
                  className="w-full border  outline-none  p-2 rounded-md"
                >
                  <select
                    // {...register('Subject')}
                    // value={titExecutive.State_ID}
                    defaultValue={
                      titExecutive.State_ID !== null
                        ? statusExeAndApr.filter(
                            (item) => item.id == titExecutive.State_ID,
                          )[0] !== undefined
                          ? statusExeAndApr.filter(
                              (item) => item.id == titExecutive.State_ID,
                            )[0]?.id
                          : null
                        : null
                    }
                    // value={
                    //   titExecutive.State_ID
                    //     ? statusExeAndApr.find(
                    //         (item) => item.ID == titExecutive.State_ID,
                    //       )?.ID || ''
                    //     : ''
                    // }
                    onChange={(e) =>
                      setTitExecutive((caseData) => ({
                        ...caseData,
                        State_ID: Number(e.target.value),
                      }))
                    }
                    className=" w-full "
                  >
                    <option
                      className="font-extralight "
                      // selected
                      // value={0}
                      hidden
                      // value={titExecutive.State_ID}
                    >
                      {titExecutive.State_ID !== null
                        ? statusExeAndApr.filter(
                            (item) => item.id == titExecutive.State_ID,
                          )[0]?.item || ''
                        : ' انتخاب کنید '}
                      {/* انتخاب کنید */}
                    </option>
                    {statusExeAndApr ? (
                      statusExeAndApr.map((item) => {
                        return (
                          <option
                            className="font-extralight "
                            key={item.id}
                            value={item.id}
                          >
                            {item.item}
                          </option>
                        );
                      })
                    ) : (
                      <div>...</div>
                    )}
                  </select>
                </div>
                {/* <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.State_ID}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      State_ID: e.target.value,
                    }))
                  }
                /> */}
              </div>
              <div className="w-full flex items-center justify-between">
                <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                  تاریخ تشکیل
                </label>
                <div className="w-full">
                  <DatePicker
                    className="custom-calendar"
                    inputClass="custom-input"
                    calendarPosition="bottom-center"
                    value={titExecutive.CreateDate}
                    locale={persian_fa}
                    // value={titExecutive.ExpireDate}
                    calendar={persian}
                    onChange={handleDateCreate}
                  />
                </div>
              </div>
              <div className="w-full flex items-center justify-between">
                <label className="h-full w-[30%] text-[14px] flex items-center font-IranSans">
                  تاریخ انحلال
                </label>
                <div className="w-full">
                  <DatePicker
                    className="custom-calendar"
                    inputClass="custom-input"
                    calendarPosition="bottom-center"
                    value={titExecutive.ExpireDate}
                    locale={persian_fa}
                    // value={titExecutive.CreateDate}
                    calendar={persian}
                    onChange={handleDateExpir}
                  />
                </div>
              </div>
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  شناسه داتیک
                </label>
                <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.dotic_ID}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      dotic_ID: e.target.value,
                    }))
                  }
                />
              </div> */}

              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  وب سایت
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={
                    titExecutive.Domain === null ? '' : titExecutive.Domain
                  }
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Domain: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="w-full flex items-start justify-start my-2">
                <label className="h-full w-[15%] text-[14px] flex items-center justify-center font-IranSans">
                  سرشاخه
                </label>
                <SearchableDropDownExecutiveParentId
                // Parent_id={titleSubInfo.Parent_ID}
                />
              </div>
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  {/* شناسه دستگاه قبلی */}
                  نام قبلی
                </label>
                <SearchableDropDownExecutivePrevOrgId />
                {/* <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.PrevOrg_ID}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      PrevOrg_ID: e.target.value,
                    }))
                  }
                /> */}
              </div>
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  شناسه دستگاه بعدی
                </label>
                <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.NextOrg_ID}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      NextOrg_ID: e.target.value,
                    }))
                  }
                />
              </div> */}
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  نظرات
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.Comment}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Comment: e.target.value,
                    }))
                  }
                />
              </div>
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  شناسه کاربر
                </label>
                <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.User_ID}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      User_ID: e.target.value,
                    }))
                  }
                />
              </div> */}
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  شناسه گزارش
                </label>
                <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.Report_ID}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Report_ID: e.target.value,
                    }))
                  }
                />
              </div> */}
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  قانون های بالایی
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.TopLaws}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      TopLaws: e.target.value,
                    }))
                  }
                />
              </div> */}
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  موضوع بالایی
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.TopTopic}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      TopTopic: e.target.value,
                    }))
                  }
                />
              </div> */}
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  سربرگ
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.Header}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Header: e.target.value,
                    }))
                  }
                />
              </div> */}
              {/* <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  نمایه
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titExecutive.Icon}
                  // value={}
                  onChange={(e) =>
                    setTitExecutive((caseData) => ({
                      ...caseData,
                      Icon: e.target.value,
                    }))
                  }
                />
              </div> */}
            </div>
            <div className="mt-5">
              <div className="w-full flex items-center justify-between ">
                <div className="flex items-center mb-4">
                  <label
                    htmlFor="default-checkbo"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    عدم نمایش در سامانه{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitExecutive((caseData) => ({
                        ...caseData,
                        inActive: e.target.checked,
                      }))
                    }
                    id="default-checkbo"
                    type="checkbox"
                    checked={titExecutive.inActive}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
                <div className="flex items-center mb-4">
                  <label
                    htmlFor="default-checkbox"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    آیا سازمان غیر ایرانی است؟{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitExecutive((caseData) => ({
                        ...caseData,
                        isForign: e.target.checked,
                      }))
                    }
                    id="default-checkbox"
                    type="checkbox"
                    checked={titExecutive.isForign}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
                <div className="flex items-center mb-4">
                  <label
                    htmlFor="default-checkb"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    پوشه بندی و دسته بندی دستگاه{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitExecutive((caseData) => ({
                        ...caseData,
                        IsCategory: e.target.checked,
                      }))
                    }
                    id="default-checkb"
                    type="checkbox"
                    checked={titExecutive.IsCategory}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
                <div className="flex items-center mb-4">
                  <label
                    htmlFor="default-chec"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    آیا دستگاه مجری است؟{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitExecutive((caseData) => ({
                        ...caseData,
                        IsExecutor: e.target.checked,
                      }))
                    }
                    id="default-chec"
                    type="checkbox"
                    checked={titExecutive.IsExecutor}
                    defaultChecked={toggleDToM}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  />
                </div>
              </div>

              {/* <div className="w-full flex items-center  col-span-1	mb-1">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  تعریف
                </label>
                <textarea
                  value={titleSubInfo.Definition}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Definition: e.target.value,
                    }))
                  }
                  // name=""
                  rows={4}
                  className="w-full border  outline-none  p-2 rounded-md"
                  // className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  // placeholder="Write your thoughts here..."
                  // id=""
                ></textarea>
             
              </div>
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  کلید واژه ها
                </label>
                <textarea
                  value={titleSubInfo.Keywords}
                  onChange={(e) =>
                    setTitleSubInfo((caseData) => ({
                      ...caseData,
                      Keywords: e.target.value,
                    }))
                  }
                  // name=""
                  rows={4}
                  className="w-full border  outline-none  p-2 rounded-md"
                  // className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  // placeholder="Write your thoughts here..."
                  // id=""
                ></textarea>
              
              </div> */}
            </div>
            <div className="w-full h-full flex items-center ltr gap-5 mt-10">
              <button
                onClick={upsertSubFun}
                className="w-32 p-2  font-IranSans rounded-full flex items-center justify-center text-[16px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
              >
                ثبت
                <CiEdit size={25} className="ml-2" />
              </button>
              <button
                onClick={newSubFun}
                className="w-32 p-2 rounded-full text-[16px] text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black font-IranSans"
              >
                جدید <IoNewspaperOutline className="ml-3" />
              </button>
              {/* <button
                    className="w-32 p-2  font-IranSans rounded-full text-[16px] text-white font-bold flex items-center justify-center
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  >
                    حذف
                    <MdDeleteForever className="ml-3" />
                  </button> */}
            </div>
          </div>
          {/* </div> */}
          {/* </div> */}
        </div>
        <div className="mt-4">
          <h3 className="font-bold text-center">
            نمونه دستگاه های اجرایی در متن قوانین
          </h3>
          <div className="card-with-scroll overflow-x-scroll min-h-30 max-h-40 border border-gray-300 rounded-md mt-1 p-4">
            {executivSectionText?.map((item, i) => {
              return (
                <p key={i}>
                  {i + 1}... {item.sectionText}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CardTitlesExecutiveAndApproval;
